import { render } from "./rooms.vue?vue&type=template&id=1f143ba6&scoped=true"
import script from "./rooms.vue?vue&type=script&lang=js"
export * from "./rooms.vue?vue&type=script&lang=js"

import "./rooms.vue?vue&type=style&index=0&id=1f143ba6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f143ba6"]])

export default __exports__